import { render, staticRenderFns } from "./AnimationsPage.vue?vue&type=template&id=58ed8ccc&scoped=true&"
import script from "./AnimationsPage.vue?vue&type=script&lang=js&"
export * from "./AnimationsPage.vue?vue&type=script&lang=js&"
import style0 from "./AnimationsPage.vue?vue&type=style&index=0&id=58ed8ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed8ccc",
  null
  
)

export default component.exports